
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import PSubtitle from '../PSubtitle.vue'
  import GCostField from '@/components/core/input/GCostField.vue'

@Component({
  components: { PTitle, GTextarea, PSubtitle, GCostField },
})
  export default class ConfigAppraisal extends GenioView {
  formData = {
    maxDays: 7,
    maxMileage: 0,
    maxMileageConsignment: 0,
    maxPrepaidMaintenances: 0,
    validAppraisalDays: 0,
    maxOwners: 0,
    maximumPenaltiesDays: 0,
  }

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

        const fields = {
          id: this.process.id,
          config: {
            ...this.process.config,
            settings: {
              ...this.process.config.settings,
              maxMileageAllowed: parseInt(this.formData.maxMileage.toString()),
              maxMileageConsignment: parseInt(this.formData.maxMileageConsignment.toString()),
              // daysToExpire: parseInt(this.formData.maxDays.toString()),
              maxPrepaidMaintenances: parseInt(this.formData.maxPrepaidMaintenances.toString()),
              validAppraisalDays: parseInt(this.formData.validAppraisalDays.toString()),
            },
          },
        }

      await this.updateProcess(fields)

      const serialization = await this.fetchData({
        query: { name: 'find', model: 'Serialization' },
        filter: { file_type: { name: { _eq: 'cav' } } },
      })
      const appraisal = serialization.find(s => s.service === 'appraisal')
      await this.pushData({
        model: 'Serialization',
        fields: {
          id: appraisal.id,
          config: {
            ...appraisal.config,
            postJobs: {
              ...appraisal.config.postJobs,
              setExpirationDate: {
                ...appraisal.config.setExpirationDate,
                daysToExpire: parseInt(this.formData.maxDays.toString()),
              },
            },
            queueJobs: {
              ...appraisal.config.queueJobs,
              validations: {
                ...appraisal.config.queueJobs.validations,
                exe: {
                  ...appraisal.config.queueJobs.validations.exe,
                  ValidateOwnersMAX: {
                    ...appraisal.config.queueJobs.validations.exe.ValidateOwnersMAX,
                    max: parseInt(this.formData.maxOwners.toString()),
                  },
                },
              },
            },
          },
        },
      })
      const serializationPenalty = await this.fetchData({
        query: { name: 'find', model: 'Serialization' },
        filter: { file_type: { name: { _eq: 'penalty_certificate' } } },
      })
      const penalty = serializationPenalty.find(s => s.service === 'appraisal')
      await this.pushData({
        model: 'Serialization',
        fields: {
          id: penalty.id,
          config: {
            ...penalty.config,
            postJobs: {
              ...penalty.config.postJobs,
              setExpirationDate: {
                ...penalty.config.setExpirationDate,
                daysToExpire: parseInt(this.formData.maximumPenaltiesDays.toString()),
              },
            },
          },
        },
      })

      const maintenanceProcess = (await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'maintenance' } },
    }))[0]
      const fieldsMaintenance = {
          id: maintenanceProcess.id,
          config: {
            ...maintenanceProcess.config,
            maxPrepaidMaintenances: parseInt(this.formData.maxPrepaidMaintenances.toString()),
        },
      }

      await this.updateProcess(fieldsMaintenance)

      this.$emit('update')
    }

  @Watch('process', { immediate: true, deep: true })
  async onConfigChange (newValue: any) {
    if (newValue?.config?.settings) {
      const serialization = await this.fetchData({
        query: { name: 'find', model: 'Serialization' },
        filter: { file_type: { name: { _eq: 'cav' } } },
      })

      const appraisal = serialization.find(s => s.service === 'appraisal')

      const serializationPenalty = await this.fetchData({
        query: { name: 'find', model: 'Serialization' },
        filter: { file_type: { name: { _eq: 'penalty_certificate' } } },
      })

      const penalty = serializationPenalty.find(s => s.service === 'appraisal')

      this.formData = {
        maxDays: appraisal?.config?.postJobs?.setExpirationDate?.daysToExpire,
        maxMileage: newValue?.config?.settings?.maxMileageAllowed,
        maxMileageConsignment: newValue?.config?.settings?.maxMileageConsignment,
        maxPrepaidMaintenances: newValue?.config?.settings?.maxPrepaidMaintenances,
        validAppraisalDays: newValue?.config?.settings?.validAppraisalDays,
        maxOwners: appraisal?.config?.queueJobs?.validations?.exe?.ValidateOwnersMAX?.max,
        maximumPenaltiesDays: penalty?.config?.postJobs?.setExpirationDate?.daysToExpire,
      }
    }
  }
  }
